export default "__VITE_ASSET__fNIgIS7i__"